import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "sonner";
import { Navbar } from "@/components/ruota/Navbar";
import { Hero } from "@/components/ruota/Hero";
import { Marquee } from "@/components/ruota/Marquee";
import { Manifesto } from "@/components/ruota/Manifesto";
import { Destinations } from "@/components/ruota/Destinations";
import { GroupTravel } from "@/components/ruota/GroupTravel";
import { About } from "@/components/ruota/About";
import { EnquiryForm } from "@/components/ruota/EnquiryForm";
import { Testimonials } from "@/components/ruota/Testimonials";
import { Footer } from "@/components/ruota/Footer";
import { Admin } from "@/components/ruota/Admin";

const Landing = ({ preselected, setPreselected }) => {
  const lenis = useLenis();
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const target = location.state.scrollTo;
      const t = setTimeout(() => lenis?.scrollTo(target, { offset: -72, duration: 1.2 }), 350);
      return () => clearTimeout(t);
    }
  }, [location.state, lenis]);

  return (
    <main>
      <Hero />
      <Marquee />
      <Manifesto />
      <Destinations onEnquire={(name) => setPreselected(name)} />
      <GroupTravel onEnquire={(name) => setPreselected(name)} />
      <About />
      <EnquiryForm preselected={preselected} />
      <Testimonials />
    </main>
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  const [preselected, setPreselected] = useState(null);

  return (
    <BrowserRouter>
      <ReactLenis root options={{ lerp: 0.09, duration: 1.2, smoothWheel: true }}>
        <div className="min-h-screen bg-[#F7F0E3] text-[#0D1F23]">
          <ScrollToTop />
          <Toaster position="top-center" richColors closeButton />
          <Navbar />
          <Routes>
            <Route
              path="/"
              element={<Landing preselected={preselected} setPreselected={setPreselected} />}
            />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
        </div>
      </ReactLenis>
    </BrowserRouter>
  );
}

export default App;
